export default __webpack_public_path__ + "static/media/mail_badge.1c3c5879.svg";